import { Button, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

export const PrintButton = ({ onClick, disabled, text }) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    startIcon={<PrintIcon />}
    sx={{
      width: 'fit-content',
      whiteSpace: 'nowrap',
      px: '16px',
      py: '8px',
      backgroundColor: '#F5F5F5',
      color: '#000',
      justifyContent: 'center',
      '@media (min-width:900px)': {
        justifyContent: 'flex-end',
      },
    }}
  >
    <Typography fontSize={16} fontWeight={500}>
      {text}
    </Typography>
  </Button>
);
